module.exports = __webpack_public_path__ + "img/l_logo.b9b7edb3.png";